import { z } from 'zod'
import {
  OUTBOUND_EMAIL_CATEGORIES,
  OUTBOUND_EMAIL_OBJECT_TYPES,
  OUTBOUND_EMAIL_STATUSES,
} from '../enums/outbound-email.enum.js'

const outboundEmailRecipientDtoSchema = z.object({
  id: z.string().uuid(),
  address: z.string(),
  name: z.string().nullable(),
  role: z.string().nullable(),
})

const outboundEmailAttachmentDtoSchema = z.object({
  id: z.string().uuid(),
  fileName: z.string(),
  contentType: z.string(),
  sizeBytes: z.number().int().nonnegative(),
})

const outboundEmailLinkDtoSchema = z.object({
  objectType: z.enum(OUTBOUND_EMAIL_OBJECT_TYPES),
  objectId: z.string(),
})

/** List row — no HTML body. */
const outboundEmailListItemDtoSchema = z.object({
  id: z.string().uuid(),
  category: z.enum(OUTBOUND_EMAIL_CATEGORIES),
  subject: z.string(),
  fromAddress: z.string(),
  status: z.enum(OUTBOUND_EMAIL_STATUSES),
  sentAt: z.string().datetime(),
  sentByUserId: z.string().uuid().nullable(),
  sentByName: z.string().nullable(),
  recipients: z.array(outboundEmailRecipientDtoSchema),
  attachmentCount: z.number().int().nonnegative(),
})

export type OutboundEmailListItemDto = z.infer<
  typeof outboundEmailListItemDtoSchema
>

export const outboundEmailListDtoSchema = z.object({
  emails: z.array(outboundEmailListItemDtoSchema),
  total: z.number().int().nonnegative(),
})

export type OutboundEmailListDto = z.infer<typeof outboundEmailListDtoSchema>

/** Full record for the preview tray. */
export const outboundEmailDetailDtoSchema = outboundEmailListItemDtoSchema.extend({
  html: z.string(),
  text: z.string().nullable(),
  error: z.string().nullable(),
  attachments: z.array(outboundEmailAttachmentDtoSchema),
  links: z.array(outboundEmailLinkDtoSchema),
})

export type OutboundEmailDetailDto = z.infer<
  typeof outboundEmailDetailDtoSchema
>
